// eslint-disable-next-line
import { ApiConnector, GET, PUT } from './requestV2.service';

export default (() => {
    const API = ApiConnector('/game', true);
    return {
        getChestHistory: async (data, query) => await API(GET, '/chest/history', false, query).call(data),
        GetStudentVillageSettings: async (data, query) => await API(GET, '/settings/village', false, query).call(data),
        ChangeStudentVillageSettings: async (data, query) =>
            await API(PUT, '/settings/village', false, query).call(data),
        GetGameTransactions: async (data, query) =>
            await API(GET, '/chest/transactions/select', false, query).call(data),
        GetGameQuestStatistics: async (data, query) => await API(GET, '/quests/stats-by-teacher', false, query).call(data),
        GetGameQuestStatisticsByUserId: async (id, query) => await API(GET, `/quests/stats-by-id/${id}`, false, query).call(false),
    };
})();
